import { DateTime } from "luxon";
import { YM_DATE_FORMAT } from "@/constants";

export const periodToDate = (period: string): Date =>
  DateTime.fromFormat(period, YM_DATE_FORMAT).startOf("month").toJSDate();
